import { BaseActions } from './baseActions';

export class MinicartActions extends BaseActions {
  public hideMinicart(): void {
    this.siteStore.pubSubManager.publish('Minicart.Hide', null);
  }
}
